import { render, staticRenderFns } from "./AppMountFailed.vue?vue&type=template&id=3c06df28"
import script from "./AppMountFailed.vue?vue&type=script&lang=js"
export * from "./AppMountFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports